module.exports = __webpack_public_path__ + "static/media/icon_jingzhunkekao_wap.60c1e8bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/icon_jingzhunkekao_wap.svg
// module id = 492
// module chunks = 0